
<span class="p-buttonset">
    <app-pdf [membershipDetail]="membershipDetail"></app-pdf>
    <button class="m-2" pButton pRipple label="Finalizar" icon="pi pi-times" (click)="finishMembership()"></button>
</span>
